export default "__VITE_ASSET__Dlk7viQp__"